module.exports = __webpack_public_path__ + "img/luxura_vegaz.7625594a.svg";